import { fuelPlans } from "@/lib/navcalc";
import { minToHm } from "@/lib/units";

const pad3 = (v) => String(Math.round(((Number(v) || 0) % 360 + 360) % 360)).padStart(3, "0");
const frDate = (d) => (d ? d.split("-").reverse().join("/") : "");

// Données du log de nav Excel (modèle ATO ACG) : RM = Rv + décl (Ouest +), TSV = dist / Vp.
export function buildNavlogSpec(briefing, aircraft, nav) {
  const vp = Number(aircraft?.tasCruise) || 0;
  const tsv = (d) => (vp > 0 ? Math.round(((Number(d) || 0) / vp) * 60) : "");
  const plan = fuelPlans(briefing, nav, aircraft)[0].plan;
  const dep = briefing.departure || "?";
  const arr = briefing.arrival || "?";
  const sheet = (title, legs, from, to, heading, atis) => ({
    title, heading, atis_point_id: atis,
    trajet: `${from} → ${to}`,
    positions: [from, ...legs.map((l, i) => l.name || `Pt ${i + 1}`)],
    legs: legs.map((l) => ({
      alt: Number(l.altitude) || "", rm: pad3((Number(l.trackTrue) || 0) + (Number(l.variation) || 0)),
      dist: Number(l.distance) || 0, tsv: tsv(l.distance),
    })),
    notes: legs.map((l) => (l.frequencies || []).map((f) => [f.type, f.name, f.freq].filter(Boolean).join(" ")).join(" / ")),
    totals: {
      dist: legs.reduce((s, l) => s + (Number(l.distance) || 0), 0),
      tsv: vp > 0 ? legs.reduce((s, l) => s + tsv(l.distance), 0) : "",
    },
  });
  const sheets = nav.ret
    ? [sheet("Aller", briefing.legs || [], dep, arr, "LOG DE NAVIGATION (ALLER)", "atis::aller"),
      sheet("Retour", briefing.returnLegs || [], arr, dep, "LOG DE NAVIGATION (RETOUR)", "atis::retour")]
    : [sheet("Log de nav", briefing.legs || [], dep, arr, "LOG DE NAVIGATION", "atis::aller")];
  return {
    date: frDate(briefing.navDate),
    immat: aircraft?.registration || "",
    vp: vp ? `${vp} kt` : "",
    fb: vp ? (60 / vp).toFixed(2) : "",
    autonomie: plan.onboard ? `${minToHm(plan.endurance)} (${Math.round(plan.onboard)} L)` : "",
    sheets,
  };
}
